namespace GeniuzPOS.PosShift {
    export interface PsVatRefundPrintingParaForm {
        FromCode: Serenity.StringEditor;
        P1Height: Serenity.DecimalEditor;
        P1Width: Serenity.DecimalEditor;
        P1PaddingTop: Serenity.DecimalEditor;
        P1PaddingLeft: Serenity.DecimalEditor;
        P1HeaderHeight: Serenity.DecimalEditor;
        P1HeaderLeftWidth: Serenity.DecimalEditor;
        P1HeaderRightWidth: Serenity.DecimalEditor;
        P1HeaderRightPaddingTop: Serenity.DecimalEditor;
        P1HeaderLeftShopTaxIdPaddingLeft: Serenity.DecimalEditor;
        P1HeaderLeftShopTaxIdPaddingRight: Serenity.DecimalEditor;
        P1HeaderLeftShopTaxIdHeight: Serenity.DecimalEditor;
        P1HeaderLeftShopTaxIdFontSize: Serenity.DecimalEditor;
        P1HeaderLeftShopTaxIdSpacing: Serenity.DecimalEditor;
        P1HeaderLeftBranchPaddingLeft: Serenity.DecimalEditor;
        P1HeaderLeftBranchPaddingRight: Serenity.DecimalEditor;
        P1HeaderLeftBranchHeight: Serenity.DecimalEditor;
        P1HeaderLeftBranchFontSize: Serenity.DecimalEditor;
        P1HeaderLeftBranchSpacing: Serenity.DecimalEditor;
        P1HeaderLeftCompanyNamePaddingLeft: Serenity.DecimalEditor;
        P1HeaderLeftCompanyNameFontSize: Serenity.DecimalEditor;
        P1HeaderLeftAddNoPaddingLeft: Serenity.DecimalEditor;
        P1HeaderLeftAddNoHeight: Serenity.DecimalEditor;
        P1HeaderLeftAddNoWidth: Serenity.DecimalEditor;
        P1HeaderLeftAddNoFontSize: Serenity.DecimalEditor;
        P1HeaderLeftStreetPaddingLeft: Serenity.DecimalEditor;
        P1HeaderLeftStreetFontSize: Serenity.DecimalEditor;
        P1HeaderLeftDistrictPaddingLeft: Serenity.DecimalEditor;
        P1HeaderLeftDistrictHeight: Serenity.DecimalEditor;
        P1HeaderLeftDistrictWidth: Serenity.DecimalEditor;
        P1HeaderLeftDistrictFontSize: Serenity.DecimalEditor;
        P1HeaderLeftProvicePaddingLeft: Serenity.DecimalEditor;
        P1HeaderLeftProviceFontSize: Serenity.DecimalEditor;
        P1HeaderLeftTelnoPaddingLeft: Serenity.DecimalEditor;
        P1HeaderLeftTelnoHeight: Serenity.DecimalEditor;
        P1HeaderLeftTelnoFontSize: Serenity.DecimalEditor;
        P1HeaderRightTNamePaddingLeft: Serenity.DecimalEditor;
        P1HeaderRightTNameHeight: Serenity.DecimalEditor;
        P1HeaderRightTNameFontSize: Serenity.DecimalEditor;
        P1HeaderRightNationPaddingLeft: Serenity.DecimalEditor;
        P1HeaderRightNationHeight: Serenity.DecimalEditor;
        P1HeaderRightNationFontSize: Serenity.DecimalEditor;
        P1HeaderRightPassnoPaddingLeft: Serenity.DecimalEditor;
        P1HeaderRightPassnoHeight: Serenity.DecimalEditor;
        P1HeaderRightPassnoFontSize: Serenity.DecimalEditor;
        P1HeaderRightDatePaddingTop: Serenity.DecimalEditor;
        P1HeaderRightDateHeight: Serenity.DecimalEditor;
        P1HeaderRightDateFontSize: Serenity.DecimalEditor;
        P1HeaderRightDateLeftPaddingLeft: Serenity.DecimalEditor;
        P1HeaderRightDateLeftWidth: Serenity.DecimalEditor;
        P1HeaderRightDateLeftMmyyWidth: Serenity.DecimalEditor;
        P1HeaderRightDateRightPaddingLeft: Serenity.DecimalEditor;
        P1HeaderRightDateRightWidth: Serenity.DecimalEditor;
        P1HeaderRightDateRightMmyyWidth: Serenity.DecimalEditor;
        P1DetailLeftWidth: Serenity.DecimalEditor;
        P1DetailLeftHeight: Serenity.DecimalEditor;
        P1DetailLeftTablePaddingTop: Serenity.DecimalEditor;
        P1DetailLeftTablePaddingLeft: Serenity.DecimalEditor;
        P1DetailLeftTableRowHeight: Serenity.DecimalEditor;
        P1DetailLeftTableC1Width: Serenity.DecimalEditor;
        P1DetailLeftTableC2Width: Serenity.DecimalEditor;
        P1DetailLeftTableC3Width: Serenity.DecimalEditor;
        P1DetailLeftTableC4Width: Serenity.DecimalEditor;
        P1DetailLeftTableC5Width: Serenity.DecimalEditor;
        P1DetailLeftTableC5PeddingRight: Serenity.DecimalEditor;
        P1DetailRightWidth: Serenity.DecimalEditor;
        P1DetailRightPaddingTop: Serenity.DecimalEditor;
        P1DetailAddressPHeight: Serenity.DecimalEditor;
        P1DetailAddressPaddingLeft: Serenity.DecimalEditor;
        P1DetailAddressPaddingTop: Serenity.DecimalEditor;
        P1DetailAddressFontSize: Serenity.DecimalEditor;
        P1DetailLine2PHeight: Serenity.DecimalEditor;
        P1DetailLine2PaddingTop: Serenity.DecimalEditor;
        P1DetailLine2FontSize: Serenity.DecimalEditor;
        P1DetailLine2PostcodePaddingWidth: Serenity.DecimalEditor;
        P1DetailLine2PostcodePaddingLeft: Serenity.DecimalEditor;
        P1DetailLine2CityPaddingWidth: Serenity.DecimalEditor;
        P1DetailLine2CityPaddingLeft: Serenity.DecimalEditor;
        P1DetailLine2CountyPaddingLeft: Serenity.DecimalEditor;
        P1DetailEmailPHeight: Serenity.DecimalEditor;
        P1DetailEmailPaddingLeft: Serenity.DecimalEditor;
        P1DetailEmailPaddingTop: Serenity.DecimalEditor;
        P1DetailEmailFontSize: Serenity.DecimalEditor;
        P1DetailPhonenumberPHeight: Serenity.DecimalEditor;
        P1DetailPhonenumberPaddingLeft: Serenity.DecimalEditor;
        P1DetailPhonenumberPaddingTop: Serenity.DecimalEditor;
        P1DetailPhonenumberFontSize: Serenity.DecimalEditor;
        P1FooterLeftWidth: Serenity.DecimalEditor;
        P1FooterLeftHeight: Serenity.DecimalEditor;
        P1FooterPagetoWidth: Serenity.DecimalEditor;
        P1FooterPagetoHeight: Serenity.DecimalEditor;
        P1FooterPagetoPaddingButtom: Serenity.DecimalEditor;
        P1FooterPagetoPaddingLeft: Serenity.DecimalEditor;
        P1FooterPagetoFontSize: Serenity.DecimalEditor;
        P1FooterSumWidth: Serenity.DecimalEditor;
        P1FooterSumPeddingRight: Serenity.DecimalEditor;
        P1FooterSumFontSize: Serenity.DecimalEditor;
        P1FooterPageNext: Serenity.DecimalEditor;
        P2StartHeight: Serenity.DecimalEditor;
        P2Height: Serenity.DecimalEditor;
        P2Width: Serenity.DecimalEditor;
        P2PaddingTop: Serenity.DecimalEditor;
        P2PaddingLeft: Serenity.DecimalEditor;
        P2PaddingRight: Serenity.DecimalEditor;
        P2PageHeight: Serenity.DecimalEditor;
        P2PageLeft: Serenity.DecimalEditor;
        P2PageNowFontSize: Serenity.DecimalEditor;
        P2PageNoHeight: Serenity.DecimalEditor;
        P2PageNowPaddingLeft: Serenity.DecimalEditor;
        P2PageNowWidth: Serenity.DecimalEditor;
        P2PageAllPaddingLeft: Serenity.DecimalEditor;
        P2HeaderBookNoHeight: Serenity.DecimalEditor;
        P2HeaderBookNoPaddingButtom: Serenity.DecimalEditor;
        P2HeaderBookNoPaddingLeft: Serenity.DecimalEditor;
        P2HeaderBookNoWidth: Serenity.DecimalEditor;
        P2HeaderNoPaddingLeft: Serenity.DecimalEditor;
        P2HeaderTaxBranchHeight: Serenity.DecimalEditor;
        P2HeaderTaxBranchFontSize: Serenity.DecimalEditor;
        P2HeaderTaxHeight: Serenity.DecimalEditor;
        P2HeaderTaxPaddingLeft: Serenity.DecimalEditor;
        P2HeaderTaxPaddingRigth: Serenity.DecimalEditor;
        P2HeaderTaxSpacing: Serenity.DecimalEditor;
        P2HeaderBranchHeight: Serenity.DecimalEditor;
        P2HeaderBranchPaddingLeft: Serenity.DecimalEditor;
        P2HeaderBranchPaddingRigth: Serenity.DecimalEditor;
        P2HeaderBranchSpacing: Serenity.DecimalEditor;
        P2HeaderSaleHeight: Serenity.DecimalEditor;
        P2HeaderSalePaddingButtom: Serenity.DecimalEditor;
        P2HeaderSalePaddingLeft: Serenity.DecimalEditor;
        P2HeaderSaleFontSize: Serenity.DecimalEditor;
        P2DetailWidth: Serenity.DecimalEditor;
        P2DetailHeight: Serenity.DecimalEditor;
        P2DetailPaddingTop: Serenity.DecimalEditor;
        P2DetailPaddingLeft: Serenity.DecimalEditor;
        P2DetailPaddingRight: Serenity.DecimalEditor;
        P2DetailRowHeight: Serenity.DecimalEditor;
        P2DetailC1Width: Serenity.DecimalEditor;
        P2DetailC2Width: Serenity.DecimalEditor;
        P2DetailC2PaddingLeft: Serenity.DecimalEditor;
        P2DetailC3Width: Serenity.DecimalEditor;
        P2DetailC3PaddingLeft: Serenity.DecimalEditor;
        P2DetailC4Width: Serenity.DecimalEditor;
        P2DetailC4PaddingLeft: Serenity.DecimalEditor;
        P2DetailC5Width: Serenity.DecimalEditor;
        P2DetailC5PaddingRight: Serenity.DecimalEditor;
        P2FooterWidth: Serenity.DecimalEditor;
        P2FooterHeight: Serenity.DecimalEditor;
        P2FooterLeft: Serenity.DecimalEditor;
        P2FooterSumPaddingRight: Serenity.DecimalEditor;
        P2FooterPageNext: Serenity.DecimalEditor;
    }

    export class PsVatRefundPrintingParaForm extends Serenity.PrefixedContext {
        static formKey = 'PosShift.PsVatRefundPrintingPara';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PsVatRefundPrintingParaForm.init)  {
                PsVatRefundPrintingParaForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.DecimalEditor;

                Q.initFormType(PsVatRefundPrintingParaForm, [
                    'FromCode', w0,
                    'P1Height', w1,
                    'P1Width', w1,
                    'P1PaddingTop', w1,
                    'P1PaddingLeft', w1,
                    'P1HeaderHeight', w1,
                    'P1HeaderLeftWidth', w1,
                    'P1HeaderRightWidth', w1,
                    'P1HeaderRightPaddingTop', w1,
                    'P1HeaderLeftShopTaxIdPaddingLeft', w1,
                    'P1HeaderLeftShopTaxIdPaddingRight', w1,
                    'P1HeaderLeftShopTaxIdHeight', w1,
                    'P1HeaderLeftShopTaxIdFontSize', w1,
                    'P1HeaderLeftShopTaxIdSpacing', w1,
                    'P1HeaderLeftBranchPaddingLeft', w1,
                    'P1HeaderLeftBranchPaddingRight', w1,
                    'P1HeaderLeftBranchHeight', w1,
                    'P1HeaderLeftBranchFontSize', w1,
                    'P1HeaderLeftBranchSpacing', w1,
                    'P1HeaderLeftCompanyNamePaddingLeft', w1,
                    'P1HeaderLeftCompanyNameFontSize', w1,
                    'P1HeaderLeftAddNoPaddingLeft', w1,
                    'P1HeaderLeftAddNoHeight', w1,
                    'P1HeaderLeftAddNoWidth', w1,
                    'P1HeaderLeftAddNoFontSize', w1,
                    'P1HeaderLeftStreetPaddingLeft', w1,
                    'P1HeaderLeftStreetFontSize', w1,
                    'P1HeaderLeftDistrictPaddingLeft', w1,
                    'P1HeaderLeftDistrictHeight', w1,
                    'P1HeaderLeftDistrictWidth', w1,
                    'P1HeaderLeftDistrictFontSize', w1,
                    'P1HeaderLeftProvicePaddingLeft', w1,
                    'P1HeaderLeftProviceFontSize', w1,
                    'P1HeaderLeftTelnoPaddingLeft', w1,
                    'P1HeaderLeftTelnoHeight', w1,
                    'P1HeaderLeftTelnoFontSize', w1,
                    'P1HeaderRightTNamePaddingLeft', w1,
                    'P1HeaderRightTNameHeight', w1,
                    'P1HeaderRightTNameFontSize', w1,
                    'P1HeaderRightNationPaddingLeft', w1,
                    'P1HeaderRightNationHeight', w1,
                    'P1HeaderRightNationFontSize', w1,
                    'P1HeaderRightPassnoPaddingLeft', w1,
                    'P1HeaderRightPassnoHeight', w1,
                    'P1HeaderRightPassnoFontSize', w1,
                    'P1HeaderRightDatePaddingTop', w1,
                    'P1HeaderRightDateHeight', w1,
                    'P1HeaderRightDateFontSize', w1,
                    'P1HeaderRightDateLeftPaddingLeft', w1,
                    'P1HeaderRightDateLeftWidth', w1,
                    'P1HeaderRightDateLeftMmyyWidth', w1,
                    'P1HeaderRightDateRightPaddingLeft', w1,
                    'P1HeaderRightDateRightWidth', w1,
                    'P1HeaderRightDateRightMmyyWidth', w1,
                    'P1DetailLeftWidth', w1,
                    'P1DetailLeftHeight', w1,
                    'P1DetailLeftTablePaddingTop', w1,
                    'P1DetailLeftTablePaddingLeft', w1,
                    'P1DetailLeftTableRowHeight', w1,
                    'P1DetailLeftTableC1Width', w1,
                    'P1DetailLeftTableC2Width', w1,
                    'P1DetailLeftTableC3Width', w1,
                    'P1DetailLeftTableC4Width', w1,
                    'P1DetailLeftTableC5Width', w1,
                    'P1DetailLeftTableC5PeddingRight', w1,
                    'P1DetailRightWidth', w1,
                    'P1DetailRightPaddingTop', w1,
                    'P1DetailAddressPHeight', w1,
                    'P1DetailAddressPaddingLeft', w1,
                    'P1DetailAddressPaddingTop', w1,
                    'P1DetailAddressFontSize', w1,
                    'P1DetailLine2PHeight', w1,
                    'P1DetailLine2PaddingTop', w1,
                    'P1DetailLine2FontSize', w1,
                    'P1DetailLine2PostcodePaddingWidth', w1,
                    'P1DetailLine2PostcodePaddingLeft', w1,
                    'P1DetailLine2CityPaddingWidth', w1,
                    'P1DetailLine2CityPaddingLeft', w1,
                    'P1DetailLine2CountyPaddingLeft', w1,
                    'P1DetailEmailPHeight', w1,
                    'P1DetailEmailPaddingLeft', w1,
                    'P1DetailEmailPaddingTop', w1,
                    'P1DetailEmailFontSize', w1,
                    'P1DetailPhonenumberPHeight', w1,
                    'P1DetailPhonenumberPaddingLeft', w1,
                    'P1DetailPhonenumberPaddingTop', w1,
                    'P1DetailPhonenumberFontSize', w1,
                    'P1FooterLeftWidth', w1,
                    'P1FooterLeftHeight', w1,
                    'P1FooterPagetoWidth', w1,
                    'P1FooterPagetoHeight', w1,
                    'P1FooterPagetoPaddingButtom', w1,
                    'P1FooterPagetoPaddingLeft', w1,
                    'P1FooterPagetoFontSize', w1,
                    'P1FooterSumWidth', w1,
                    'P1FooterSumPeddingRight', w1,
                    'P1FooterSumFontSize', w1,
                    'P1FooterPageNext', w1,
                    'P2StartHeight', w1,
                    'P2Height', w1,
                    'P2Width', w1,
                    'P2PaddingTop', w1,
                    'P2PaddingLeft', w1,
                    'P2PaddingRight', w1,
                    'P2PageHeight', w1,
                    'P2PageLeft', w1,
                    'P2PageNowFontSize', w1,
                    'P2PageNoHeight', w1,
                    'P2PageNowPaddingLeft', w1,
                    'P2PageNowWidth', w1,
                    'P2PageAllPaddingLeft', w1,
                    'P2HeaderBookNoHeight', w1,
                    'P2HeaderBookNoPaddingButtom', w1,
                    'P2HeaderBookNoPaddingLeft', w1,
                    'P2HeaderBookNoWidth', w1,
                    'P2HeaderNoPaddingLeft', w1,
                    'P2HeaderTaxBranchHeight', w1,
                    'P2HeaderTaxBranchFontSize', w1,
                    'P2HeaderTaxHeight', w1,
                    'P2HeaderTaxPaddingLeft', w1,
                    'P2HeaderTaxPaddingRigth', w1,
                    'P2HeaderTaxSpacing', w1,
                    'P2HeaderBranchHeight', w1,
                    'P2HeaderBranchPaddingLeft', w1,
                    'P2HeaderBranchPaddingRigth', w1,
                    'P2HeaderBranchSpacing', w1,
                    'P2HeaderSaleHeight', w1,
                    'P2HeaderSalePaddingButtom', w1,
                    'P2HeaderSalePaddingLeft', w1,
                    'P2HeaderSaleFontSize', w1,
                    'P2DetailWidth', w1,
                    'P2DetailHeight', w1,
                    'P2DetailPaddingTop', w1,
                    'P2DetailPaddingLeft', w1,
                    'P2DetailPaddingRight', w1,
                    'P2DetailRowHeight', w1,
                    'P2DetailC1Width', w1,
                    'P2DetailC2Width', w1,
                    'P2DetailC2PaddingLeft', w1,
                    'P2DetailC3Width', w1,
                    'P2DetailC3PaddingLeft', w1,
                    'P2DetailC4Width', w1,
                    'P2DetailC4PaddingLeft', w1,
                    'P2DetailC5Width', w1,
                    'P2DetailC5PaddingRight', w1,
                    'P2FooterWidth', w1,
                    'P2FooterHeight', w1,
                    'P2FooterLeft', w1,
                    'P2FooterSumPaddingRight', w1,
                    'P2FooterPageNext', w1
                ]);
            }
        }
    }
}
